import { createSVGIcon } from "@faire/web--source/slate/icons/util";
import * as React from "react";

export const FabricsIcon = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.44966 10.9698L0.353555 19.0659C0.158293 19.2611 0.158293 19.5777 0.353555 19.773C0.548817 19.9683 0.8654 19.9683 1.06066 19.773L9.15677 11.6769L8.44966 10.9698ZM11.6755 9.15815L19.7713 1.06238C19.9665 0.867118 19.9665 0.550535 19.7713 0.355273C19.576 0.160011 19.2594 0.160011 19.0642 0.355273L10.9684 8.45104L11.6755 9.15815Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3237 22.8433L12.2276 30.9394C12.0323 31.1347 12.0323 31.4513 12.2276 31.6465C12.4228 31.8418 12.7394 31.8418 12.9347 31.6465L21.0308 23.5504L20.3237 22.8433ZM23.5495 21.0317L31.6453 12.9359C31.8406 12.7407 31.8406 12.4241 31.6453 12.2288C31.45 12.0335 31.1334 12.0335 30.9382 12.2288L22.8424 20.3246L23.5495 21.0317Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.71895 22.573L6.29008 25.0019C6.09482 25.1972 6.09482 25.5138 6.29008 25.709C6.48534 25.9043 6.80192 25.9043 6.99719 25.709L9.42605 23.2802L8.71895 22.573ZM11.3151 21.3911L21.3899 11.3163L20.6828 10.6092L10.608 20.684L11.3151 21.3911ZM25.7078 6.99842L23.279 9.42724L22.5719 8.72013L25.0007 6.29131C25.1959 6.09605 25.5125 6.09605 25.7078 6.29131C25.9031 6.48657 25.9031 6.80315 25.7078 6.99842Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99719 6.29146C6.80192 6.0962 6.48534 6.0962 6.29008 6.29146C6.09482 6.48673 6.09482 6.80331 6.29008 6.99857L14.3859 15.0944L15.093 14.3873L6.99719 6.29146ZM17.6118 16.906L16.9047 17.6132L25.0007 25.7092C25.1959 25.9044 25.5125 25.9044 25.7078 25.7092C25.9031 25.5139 25.9031 25.1973 25.7078 25.0021L17.6118 16.906Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.354532 12.2275C0.549794 12.0322 0.866376 12.0322 1.06164 12.2275L3.49007 14.6559L2.78296 15.363L0.354531 12.9346C0.159269 12.7393 0.159269 12.4228 0.354532 12.2275ZM4.67201 17.2521L5.37912 16.545L15.4541 26.62L14.747 27.3271L4.67201 17.2521ZM16.6361 29.2161L19.0651 31.6452C19.2604 31.8405 19.577 31.8405 19.7722 31.6452C19.9675 31.45 19.9675 31.1334 19.7722 30.9381L17.3432 28.509L16.6361 29.2161Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2286 0.353476C12.4238 0.158214 12.7404 0.158214 12.9357 0.353476L15.3643 2.78215L14.6572 3.48926L12.2286 1.06058C12.0333 0.865321 12.0333 0.548738 12.2286 0.353476ZM16.5463 5.37831L17.2534 4.6712L27.3284 14.7462L26.6213 15.4533L16.5463 5.37831ZM28.5103 17.3424L30.9392 19.7712C31.1344 19.9665 31.451 19.9665 31.6463 19.7712C31.8415 19.5759 31.8415 19.2593 31.6463 19.0641L29.2174 16.6353L28.5103 17.3424Z"
      fill="currentColor"
    />
  </>,
  "ShowroomFabricIcon",
  {
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    fill: "none",
  }
);
